module.exports = __webpack_public_path__ + "img/color-2_en.fd3c33e.jpg";